export const TERMS_PDF_URL =
  'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/khatabook-website/kb-terms-conditions.pdf&embedded=true';
